module.exports = __webpack_public_path__ + "static/img/06.7fce804.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutLanshu/06.png
// module id = 9StA
// module chunks = 0